export default {
  navigationBarTitleText: '添加增项'
};
